import React, { useState } from "react";
import { Modal, Form, Input, Select, Button, Alert } from "antd";
import { X } from "lucide-react";
const PricingTierModal = ({
  isOpen,
  onClose,
  onSubmit,
  pricingTiers,
  info,
  handleRegistrationRequest,
}) => {
  const [selectedTier, setSelectedTier] = useState(
    pricingTiers?.length ? pricingTiers[0]?.priceId : undefined
  );
  const [discountCode, setDiscountCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!selectedTier) {
      setError("Please select a pricing tier");
      return;
    }

    setLoading(true);
    setError("");

    console.log(selectedTier, discountCode);

    try {
      // if (info.requireApproval) {
      //     await handleRegistrationRequest(info.event_id);
      // }
      await onSubmit({
        tierPriceId: selectedTier || pricingTiers[0].priceId,
        discountCode: discountCode,
        eventId: info.event_id,
      });
    } catch (error) {
      setError("An error occurred. Please try again.");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={() => {
        onClose();
        setError("");
      }}
      footer={null}
      width={440}
      className="pricing-tier-modal"
      maskClosable={true}
      centered
    >
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-gray-900">
            {info.requireApproval && info.stripePriceIds.length <= 1
              ? "Continue to Checkout"
              : "Select Ticket Type"}
          </h2>
        </div>

        {error && (
          <Alert message={error} type="error" showIcon className="mb-4" />
        )}

        {info.requireApproval && (
          <p>
            This event requires organizer approval. Your selected payment method
            will only be charged once you are approved by the host.
          </p>
        )}

        <Form layout="vertical" className="space-y-4">
          {pricingTiers.length > 1 && (
            <>
              <Form.Item label="Ticket Type" required className="mb-4">
                <Select
                  value={selectedTier}
                  onChange={setSelectedTier}
                  placeholder="Select a ticket type"
                  className="w-full"
                >
                  {pricingTiers.map((tier) => (
                    <Select.Option key={tier.priceId} value={tier.priceId}>
                      {tier.tierName} - ${(tier.amount / 100).toFixed(2)}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <p>Discounts can be applied at checkout</p>
            </>
          )}

          {/* {info.requireApproval &&
                        <Form.Item
                            label="Discount Code (Optional)"
                            className="mb-6"
                        >
                            <Input
                                value={discountCode}
                                onChange={(e) => setDiscountCode(e.target.value)}
                                placeholder="Enter discount code"
                                className="w-full"
                            />
                        </Form.Item>
                    } */}

          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
            className="w-full h-10 text-base font-medium"
          >
            {loading ? "Processing..." : "Continue to Checkout"}
          </Button>
        </Form>
      </div>
    </Modal>
  );
};

export default PricingTierModal;
